import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home';
import GlobalStyles from './index.style';
import Header from './components/HeaderNav';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import Chat from './pages/Chat';
import UserProfile from './components/UserProfile';
import SettingForm from './components/Setting';
import ArticleModal from './pages/Home/ArticleProfile';
import { getUserRequest } from './actions';
import NotFoundPage from './pages/404Page';

const App = () => {
  const colors = useSelector((state: any) => state.colors);
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    localStorage.getItem('token') && dispatch(getUserRequest());
  }, []);

  return (
    <ThemeProvider theme={colors}>
      <GlobalStyles />
      <Router>
        <Header />
        <Switch>
          <Redirect exact from="/" to="/home" />
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/login">
            <SignIn />
          </Route>
          <Route
            path="/setting"
            render={() =>
              user?.userInfo?.token || localStorage.getItem('token') ? (
                <SettingForm />
              ) : (
                <SignIn />
              )
            }
          />
          <Route
            path="/chat"
            render={() =>
              user?.userInfo?.token || localStorage.getItem('token') ? (
                <Chat />
              ) : (
                <SignIn />
              )
            }
          />
          <Route path="/register">
            <SignUp />
          </Route>
          <Route path="/profile/:username">
            <UserProfile />
          </Route>
          <Route path="/setting">
            <SettingForm />
          </Route>
          <Route path="/articles/:slug">
            <ArticleModal />
          </Route>
          <Route path="*">
            <NotFoundPage />
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  );
};

export default App;
